module.exports = __webpack_public_path__ + "static/media/Retail.710bdcd8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/Tracks/img/newlogos/Retail.svg
// module id = 247
// module chunks = 0